import React, { useContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { StepContainer } from '../step-container/step-container';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';
import { WIZARD_ACTIONS } from '../../goal-creation-wizard-reducer';
import { GoalTypeView } from './goal-type-view';
import { endActivity } from '../../shared/util';

const GoalTypeSelectionUnstyled = (props) => {
  const {
    selectedObjective,
    classes,
    permissions,
    autoGoalBackHandlerFunc,
    autoGoalSelectedObjective,
  } = props;
  const i18n = useContext(I18nContext);
  const wizardContext = useContext(GoalCreationWizardContext);
  const { logActivity } = wizardContext;
  const { GoalCategory, Type } = wizardContext.goalContext; // undefined if it is a new goal
  const [goalSelection, setGoalSelection] = useState({ GoalCategory, Type });

  const updateGoalSelection = useCallback((data) => {
    setGoalSelection({
      ...goalSelection,
      ...data,
    });
  }, [goalSelection]);

  const handleNext = useCallback(() => {
    logActivity.trace(`Selected goal type:${JSON.stringify(goalSelection)}`);
    endActivity(logActivity);
    wizardContext.dispatch({
      type: WIZARD_ACTIONS.SAVE_AND_NAVIGATE_DETAILS,
      data: { ...goalSelection },
    });
  }, [logActivity, goalSelection, wizardContext]);

  const footerConfig = useMemo(() => {
    const buttons = [
      {
        type: 'Primary',
        onClick: handleNext,
        isEnabled: !_.isUndefined(goalSelection.GoalCategory) && goalSelection.GoalCategory !== 'None' && !_.isUndefined(goalSelection.Type),
        text: i18n.getString(_TL_('Next')),
      },
      {
        type: 'Cancel',
        onClick: wizardContext.cancel,
        isEnabled: true,
        text: i18n.getString(_TL_('Cancel')),
      }];

    if (!autoGoalSelectedObjective) {
      buttons.unshift({
        type: 'Secondary',
        onClick: wizardContext.goBack,
        isEnabled: !wizardContext.isEditScenario,
        text: i18n.getString(_TL_('Back')),
      });
    }

    if (autoGoalBackHandlerFunc) {
      buttons.push({
        type: 'BasicLink',
        onClick: autoGoalBackHandlerFunc,
        isEnabled: true,
        text: i18n.getString(_TL_('Switch to simplified setup')),
      });
    }
    return { buttons };
  }, [autoGoalBackHandlerFunc, autoGoalSelectedObjective, goalSelection.GoalCategory, goalSelection.Type, handleNext, i18n, wizardContext.cancel, wizardContext.goBack, wizardContext.isEditScenario]);
  return (
    <StepContainer
      title={i18n.getString(_TL_('What type of goal do you want to set?'))}
      step="goal-type"
      footerConfig={footerConfig}
    >
      <div className={classes.contentBlock}>
        <GoalTypeView
          selectedObjective={selectedObjective}
          updateGoalSelection={updateGoalSelection}
          permissions={permissions}
        />
      </div>
    </StepContainer>

  );
};

GoalTypeSelectionUnstyled.propTypes = {
  selectedObjective: PropTypes.string.isRequired,
  permissions: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape(_.mapObject(
    getStepStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  autoGoalBackHandlerFunc: PropTypes.func,
  autoGoalSelectedObjective: PropTypes.string,
};

GoalTypeSelectionUnstyled.defaultProps = {
  autoGoalBackHandlerFunc: null,
  autoGoalSelectedObjective: null,
};
export const GoalTypeStep = withPerfMarker(withDefaultStyles(GoalTypeSelectionUnstyled, getStepStyles));
